import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { from } from 'rxjs';
import { FieldNumberComponent } from '../field-number.component'

@Component({
  selector: 'app-basic-field-number-r',
  templateUrl: './basic-field-number-r.component.html',
  styleUrls: ['./../Field-Styles.scss'],
})
export class BasicFieldNumberRComponent extends FieldNumberComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
